export const mapApiToForm = (res) => {
  if (!res) return {};

  return {
    customerAddressIsSetAsDefault: res.isSingleFreight ?? "",

    // ✅ Miscellaneous Charges
    Miscellaneouscurrency: res.misCharges?.currency?.id ?? "",
    Miscellaneousexrate: res.misCharges?.exchangeRate ?? "",
    Miscellaneousrate: res.misCharges?.rate ?? "",
    Miscellaneousamount: res.misCharges?.amount ?? "",
    Miscellaneousremark: res.misCharges?.remarks ?? "",

    // ✅ Agency Charges
    agencycurrency: res.agencyCharges?.currency?.id ?? "",
    AgencyexchgRate: res.agencyCharges?.exchangeRate ?? "",
    Agencyrate: res.agencyCharges?.rate ?? "",
    Agencyamount: res.agencyCharges?.amount ?? "",

    // ✅ Discount Charges (TEXT FIELD – NOT CURRENCY)
    Discountcurrency: "", // ✅ normal text only
    DiscountexchgRate: res.discountCharges?.exchangeRate ?? "",
    Discountrate: res.discountCharges?.rate ?? "",
    Discountamount: res.discountCharges?.amount ?? "",
    Discountremark: res.discountCharges?.remarks ?? "",

    // ✅ Loading Charges
    Loadingcurrency: res.loadingCharges?.currency?.id ?? "",
    LoadingexchgRate: res.loadingCharges?.exchangeRate ?? "",
    Loadingrate: res.loadingCharges?.rate ?? "",
    Loadingamount: res.loadingCharges?.amount ?? "",

    // ✅ Freight Charges
    Freightcurrency: res.freightCharges?.currency?.id ?? "",
    FreightexchangeRate: res.freightCharges?.exchangeRate ?? "",
    Freightrate: res.freightCharges?.rate ?? "",
    Freightamount: res.freightCharges?.amount ?? "",

    // ✅ Insurance Charges
    Insurancecurrency: res.insuranceCharges?.currency?.id ?? "",
    Insuranceexchangerate: res.insuranceCharges?.exchangeRate ?? "",
    Insurancerate: res.insuranceCharges?.rate ?? "",
    Insuranceamoud: res.insuranceCharges?.amount ?? "",

    // ✅ Addl Duty Charges
    Addlcurrency: res.addlDutyCharges?.currency?.name ?? "INR",
    Addlexchangerate: res.addlDutyCharges?.exchangeRate ?? "",
    Addlrate: res.addlDutyCharges?.rate ?? "",
    Addlamount: res.addlDutyCharges?.amount ?? "",

    // ✅ Revenue Deposit
    Revenuerate: res.revenueDeposit?.rate ?? "",
    Revenueremark: res.revenueDeposit?.on ?? "",

    // ✅ Landing Charge
    Landingrate: res.landingCharge?.rate ?? "",
  };
};

export const mapFormToApi = (values) => {
  return {
    isSingleFreight: values.customerAddressIsSetAsDefault ?? null,

    // ✅ Miscellaneous Charges
    misCharges: {
      currencyId: values.Miscellaneouscurrency || null,
      exchangeRate: Number(values.Miscellaneousexrate) || 0,
      rate: Number(values.Miscellaneousrate) || 0,
      amount: Number(values.Miscellaneousamount) || 0,
      remarks: values.Miscellaneousremark || null,
    },

    // ✅ Agency Charges
    agencyCharges: {
      currencyId: values.agencycurrency || null,
      exchangeRate: Number(values.AgencyexchgRate) || 0,
      rate: Number(values.Agencyrate) || 0,
      amount: Number(values.Agencyamount) || 0,
      remarks: null,
    },

    // ✅ Discount Charges (TEXT FIELD – no currency)
    discountCharges: {
      currencyId: null, // ✅ confirmed normal text field
      exchangeRate: Number(values.DiscountexchgRate) || 0,
      rate: Number(values.Discountrate) || 0,
      amount: Number(values.Discountamount) || 0,
      remarks: values.Discountremark || null,
    },

    // ✅ Loading Charges
    loadingCharges: {
      currencyId: values.Loadingcurrency || null,
      exchangeRate: Number(values.LoadingexchgRate) || 0,
      rate: Number(values.Loadingrate) || 0,
      amount: Number(values.Loadingamount) || 0,
      remarks: null,
    },

    // ✅ Freight Charges
    freightCharges: {
      currencyId: values.Freightcurrency || null,
      exchangeRate: Number(values.FreightexchangeRate) || 0,
      rate: Number(values.Freightrate) || 0,
      amount: Number(values.Freightamount) || 0,
      remarks: null,
    },

    // ✅ Insurance Charges
    insuranceCharges: {
      currencyId: values.Insurancecurrency || null,
      exchangeRate: Number(values.Insuranceexchangerate) || 0,
      rate: Number(values.Insurancerate) || 0,
      amount: Number(values.Insuranceamoud) || 0,
      remarks: null,
    },

    // ✅ Addl Duty Charges
    addlDutyCharges: {
      currencyId: values.Addlcurrency || null,
      exchangeRate: Number(values.Addlexchangerate) || 0,
      rate: Number(values.Addlrate) || 0,
      amount: Number(values.Addlamount) || 0,
      remarks: null,
    },

    // ✅ Revenue Deposit
    revenueDeposit: {
      rate: Number(values.Revenuerate) || 0,
      on: values.Revenueremark || null,
    },

    // ✅ Landing Charge
    landingCharge: {
      rate: Number(values.Landingrate) || 0,
    },
  };
};
